module.exports = __webpack_public_path__ + "static/media/cert_141.687b3db2.jpg";